import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/svgs/Diamond.svg';
import _imports_1 from '@/assets/svgs/save.svg';
import _imports_2 from '@/assets/svgs/checked.svg';
const _hoisted_1 = {
  class: "membership-privilege"
};
const _hoisted_2 = {
  class: "membership-top"
};
const _hoisted_3 = {
  class: "membership-header"
};
const _hoisted_4 = {
  class: "membership-title"
};
const _hoisted_5 = {
  class: "seat-selector"
};
const _hoisted_6 = {
  class: "seat-row"
};
const _hoisted_7 = {
  class: "seat-input-wrapper"
};
const _hoisted_8 = {
  class: "seat-price"
};
const _hoisted_9 = {
  class: "origin"
};
const _hoisted_10 = {
  class: "origin-price"
};
const _hoisted_11 = {
  class: "seat-row"
};
const _hoisted_12 = {
  class: "seat-input-wrapper"
};
const _hoisted_13 = {
  class: "seat-price"
};
const _hoisted_14 = {
  class: "origin"
};
const _hoisted_15 = {
  class: "origin-price"
};
const _hoisted_16 = {
  class: "membership-price"
};
const _hoisted_17 = {
  class: "price-main-wrapper"
};
const _hoisted_18 = {
  class: "price-current"
};
const _hoisted_19 = {
  class: "price-main"
};
const _hoisted_20 = {
  class: "price-origin"
};
const _hoisted_21 = {
  class: "price-origin-text"
};
const _hoisted_22 = {
  class: "membership-save"
};
const _hoisted_23 = {
  class: "save-badge"
};
const _hoisted_24 = {
  class: "privilege-list"
};
import { ref, computed } from "vue";
export default {
  __name: 'fleets-membership-privilege',
  props: {
    productInfo: {
      type: Object,
      default: () => ({})
    }
  },
  setup(__props) {
    const props = __props;
    const safeProductInfo = computed(() => props.productInfo || {});
    const {
      name = "",
      currency = "$",
      price = "",
      unit = "mo",
      originalPrice = "",
      months = 12,
      memberBenefits = []
    } = safeProductInfo.value;
    const operatorCount = ref(1);
    const driverCount = ref(4);
    const estimatedTotal = computed(() => (price * operatorCount.value * (months || 12) + price * driverCount.value * (months || 12)).toFixed(2));
    const originTotal = computed(() => (originalPrice * operatorCount.value * (months || 12) + originalPrice * driverCount.value * (months || 12)).toFixed(0));
    const saveAmount = computed(() => (originTotal.value - estimatedTotal.value).toFixed(0));
    return (_ctx, _cache) => {
      const _component_el_input_number = _resolveComponent("el-input-number");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[2] || (_cache[2] = _createElementVNode("img", {
        src: _imports_0,
        alt: "Diamond Membership",
        class: "membership-icon"
      }, null, -1)), _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(name)), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_cache[3] || (_cache[3] = _createElementVNode("span", {
        class: "seat-label"
      }, "Operator", -1)), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_input_number, {
        modelValue: operatorCount.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => operatorCount.value = $event),
        min: 1,
        step: 1,
        size: "small",
        "controls-position": "default",
        class: "seat-input"
      }, null, 8, ["modelValue"]), _createElementVNode("span", _hoisted_8, [_createTextVNode(_toDisplayString(_unref(currency)) + _toDisplayString(_unref(price).toFixed(2)) + " ", 1), _createElementVNode("span", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(_unref(currency) + _unref(originalPrice)), 1), _createTextVNode("/" + _toDisplayString(_unref(unit)), 1)])])])]), _createElementVNode("div", _hoisted_11, [_cache[4] || (_cache[4] = _createElementVNode("span", {
        class: "seat-label"
      }, "Driver", -1)), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_input_number, {
        modelValue: driverCount.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => driverCount.value = $event),
        min: 2,
        step: 1,
        size: "small",
        "controls-position": "default",
        class: "seat-input"
      }, null, 8, ["modelValue"]), _createElementVNode("span", _hoisted_13, [_createTextVNode(_toDisplayString(_unref(currency)) + _toDisplayString(_unref(price).toFixed(2)) + " ", 1), _createElementVNode("span", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString(_unref(currency)) + _toDisplayString(_unref(originalPrice)), 1), _createTextVNode("/" + _toDisplayString(_unref(unit)), 1)])])])])]), _createElementVNode("div", _hoisted_16, [_cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "price-total"
      }, "Total", -1)), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("span", _hoisted_19, _toDisplayString(_unref(currency) + estimatedTotal.value), 1), _cache[5] || (_cache[5] = _createElementVNode("span", {
        class: "price-year"
      }, "/year", -1))]), _createElementVNode("div", _hoisted_20, [_createElementVNode("span", _hoisted_21, _toDisplayString(_unref(currency) + originTotal.value) + "/year", 1)])])]), _createElementVNode("div", _hoisted_22, [_cache[7] || (_cache[7] = _createElementVNode("img", {
        src: _imports_1,
        alt: "save",
        class: "save-icon"
      }, null, -1)), _createElementVNode("span", _hoisted_23, "Save " + _toDisplayString(_unref(currency) + saveAmount.value), 1)])]), _createElementVNode("ul", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(memberBenefits), item => {
        return _openBlock(), _createElementBlock("li", {
          key: item,
          class: "privilege-item"
        }, [_createElementVNode("span", null, _toDisplayString(item), 1), _cache[8] || (_cache[8] = _createElementVNode("img", {
          src: _imports_2,
          alt: "check",
          class: "check-icon"
        }, null, -1))]);
      }), 128))])]);
    };
  }
};